import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const ChevronLeft: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || 24}
      height={size || 24}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.20711 3.79289C9.59763 4.18342 9.59763 4.81658 9.20711 5.20711L2.41421 12L9.20711 18.7929C9.59763 19.1834 9.59763 19.8166 9.20711 20.2071C8.81658 20.5976 8.18342 20.5976 7.79289 20.2071L0.292893 12.7071C-0.0976311 12.3166 -0.0976311 11.6834 0.292893 11.2929L7.79289 3.79289C8.18342 3.40237 8.81658 3.40237 9.20711 3.79289Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
};

export default ChevronLeft;
